module.exports = [
  {
    verticalId: 'default',
    providers: {
      GOOGLE: 50,
      FACEBOOK: 30,
      YELP: 20
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514ce9',
    name: 'Automotive',
    providers: {
      GOOGLE: 30,
      FACEBOOK: 15,
      YELP: 10,
      CARS: 20,
      DEALERRATER: 15,
      CARGURUS: 5,
      EDMUNDS: 5
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514ce8',
    name: 'Apartments',
    providers: {
      GOOGLE: 30,
      FACEBOOK: 20,
      YELP: 15,
      APARTMENTRATINGS: 15,
      APARTMENTS: 10,
      APARTMENTGUIDE: 5,
      RENT: 5
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514cea',
    name: 'Caregiving',
    providers: {
      GOOGLE: 20,
      FACEBOOK: 20,
      YELP: 15,
      CARING: 30,
      SENIORADVISOR: 10,
      APLACEFORMOM: 5
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514ced',
    name: 'Doctor',
    providers: {
      GOOGLE: 25,
      FACEBOOK: 25,
      YELP: 10,
      HEALTHGRADES: 15,
      ZOCDOC: 15,
      VITALS: 10
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514cf2',
    name: 'Realtor',
    providers: {
      GOOGLE: 20,
      FACEBOOK: 20,
      YELP: 20,
      ZILLOW: 20,
      REALTOR: 20
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514cf0',
    name: 'Hotel' ,
    providers: {
      GOOGLE: 20,
      FACEBOOK: 15,
      YELP: 10,
      TRIPADVISOR: 15,
      BOOKING: 10,
      TRAVELOCITY: 10,
      ORBITZ: 10,
      EXPEDIA: 10
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514cf3',
    name: 'Restaurant' ,
    providers: {
      GOOGLE: 30,
      FACEBOOK: 25,
      YELP: 10,
      TRIPADVISOR: 20,
      OPENTABLE: 10,
      ZOMATO: 5
    }
  },
  {
    verticalId: '5a0a0cb9d4c6ba0006514cee',
    name: 'Golf Course' ,
    providers: {
      GOOGLE: 30,
      FACEBOOK: 20,
      YELP: 10,
      GOLFADVISOR: 25,
      TRIPADVISOR: 15,
    }
  }
];
